import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/bu-admin/")({
  beforeLoad: () => {
    throw redirect({ to: "/bu-admin/dashboard", replace: true });
  },
});
